var map = {
	"./es": 190,
	"./fr": 191
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;


//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/moment/locale (en|es|fr)$
// module id = 189
// module chunks = 0